import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useIntl } from 'react-intl';
import IntlMessages from '../../components/IntlMessage';
import passengersApi from '../../api/passengers';
import countriesApi from '../../api/countries';

const { TextArea } = Input;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const { Option } = Select;
const FormPax = ({ open, onClose, currentData = {}, onReload }) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [loadingPoint, setLoadingPoint] = useState(false);
  const intl = useIntl();
  const [form] = Form.useForm();
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    filter_name: ['order_id'],
    filter_value: [currentData?.id],
  });
  const [onRefresh, setOnRefresh] = useState(false);
  useEffect(() => {
    async function fetchData() {
      let items = await passengersApi.getAll(filter);
      // console.log(' list customer', items.data);
      setItems(items.data);
      setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [filter, onRefresh]);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    async function fetchData() {
      var filter = {
        page: 1,
        limit: 1000,
        keyword: '',
        order_by: 'id',
        order_dir: 'DESC',
      };
      let bizs = await countriesApi.getAll(filter);
      setProducts(bizs.data);
    }

    fetchData();
  }, []);
  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };
  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };
  const onRemove = (data) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'global.delete_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await passengersApi.delete(data.id).catch((error) => {
          console.error(error);
          Modal.error({
            title: error.data.message,
            okText: intl.formatMessage({ id: 'global.close' }),
          });
          setLoadingPoint(false);
          setOnRefresh(!onRefresh);
        });
        setLoadingPoint(false);
        setOnRefresh(!onRefresh);
      },
      onCancel() {},
    });
  };
  const handleSubmit = () => {
    setLoadingPoint(true);
    form
      .validateFields()
      .then((values) => {
        // console.log(values);
        let data = { ...values };
        data.order_id = currentData.id;

        if (
          !data?.passport &&
          !data?.firstname &&
          !data?.lastname &&
          !data?.nationality_id
        ) {
          Modal.error({
            title: intl.formatMessage({
              id: 'error.must_contain_least_one_value',
            }),
            okText: intl.formatMessage({ id: 'global.close' }),
          });
        } else {
          if (initValue.id) {
            passengersApi
              .update(initValue.id, data)
              .then(() => {
                setInitValue(false);
                setLoadingPoint(false);
                setOnRefresh(!onRefresh);
                form.resetFields();
              })
              .catch((error) => {
                console.error(error);
                Modal.error({
                  title: error.data.message,
                  okText: intl.formatMessage({ id: 'global.close' }),
                });
                setLoadingPoint(false);
                setOnRefresh(!onRefresh);
                form.resetFields();
              });
          } else {
            passengersApi
              .create(data)
              .then(() => {
                setLoadingPoint(false);
                setOnRefresh(!onRefresh);
                form.resetFields();
              })
              .catch((error) => {
                console.error(error);
                Modal.error({
                  title: error.data.message,
                  okText: intl.formatMessage({ id: 'global.close' }),
                });
                setLoadingPoint(false);
                setOnRefresh(!onRefresh);
                form.resetFields();
              });
          }
        }
      })
      .catch(() => setLoadingPoint(false))
      .finally(() => setLoadingPoint(false));
  };
  const onFinishFailed = (errorInfo) => {
    console.error(errorInfo);
    // Modal.error({
    //   title: errorInfo,
    //   okText: intl.formatMessage({ id: "global.close" }),
    // });
  };
  const handleCancel = () => {
    onClose();
  };
  const [initValue, setInitValue] = useState({});
  const handleEdit = (record) => {
    setInitValue(record);
    form.setFieldsValue({
      firstname: record.firstname,
      lastname: record.lastname,
      passport: record.passport,
      notes: record.notes,
      nationality_id: record.nationality.id,
    });
  };

  const columns = [
    {
      title: <IntlMessages id="global.firstname" />,
      key: 'firstname',
      sorter: true,
      dataIndex: 'firstname',
      render: (text, record) => (
        <Button
          type="link"
          size="small"
          onClick={() => handleEdit(record)}
          shape="round"
        >
          {record?.firstname}
        </Button>
      ),
    },
    {
      title: <IntlMessages id="global.lastname" />,
      key: 'lastname',
      sorter: true,
      dataIndex: 'lastname',
      render: (text, record) => record?.lastname,
    },
    {
      title: <IntlMessages id="global.passport" />,
      key: 'passport',
      dataIndex: 'passport',
      render: (text, record) => record?.passport,
    },
    {
      title: <IntlMessages id="global.country" />,
      key: 'country',
      dataIndex: 'country',
      render: (text, record) => record?.nationality?.title,
    },
    {
      key: 'actions',
      width: 100,
      dataIndex: 'actions',
      render: (text, record) => (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => onRemove(record)}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  return (
    <>
      <Modal
        title={<IntlMessages id="global.add" />}
        open={true}
        width={isMobile ? '80%' : '60%'}
        destroyOnClose={true}
        onCancel={handleCancel}
        onOk={handleSubmit}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessages id="global.cancel" />}
          </Button>,
          // <Button
          //     key="submit"
          //     type="primary"
          //     htmlType="submit"
          //     // loading={loading}
          //     onClick={handleSubmit}
          // >
          //     {<IntlMessages id="global.save" />}
          // </Button>,
        ]}
      >
        <Form
          // onValuesChange={(a, b) =>
          //   a.type === 1
          //     ? form.setFieldsValue({ amount: "200" })
          //     : n
          // }
          // initialValues={initValue}
          layout="inline"
          form={form}
          labelAlign="left"
          onFinish={handleSubmit}
          onFinishFailed={onFinishFailed}
          name="horizontal_login"
        >
          <Form.Item
            name="passport"
            rules={[
              {
                required: false,
                // message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Input placeholder="Passport" />
          </Form.Item>
          <Form.Item
            name="firstname"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Input placeholder="Enter your firstname" />
          </Form.Item>
          <Form.Item
            name="lastname"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Input placeholder="Enter your lastname" />
          </Form.Item>
          <Form.Item
            name="nationality_id"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              style={{ width: '100%' }}
              showSearch
              placeholder={<IntlMessages id="global.select_county" />}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {products.map((option, index) => {
                return (
                  <Option key={`${option.id}_${index}`} value={option.id}>
                    {option.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
            {initValue.id ? (
              <IntlMessages id="global.edit" />
            ) : (
              <IntlMessages id="global.addnew" />
            )}
          </Button>
          <Form.Item
            // label={<IntlMessages id="global.notes" />}
            style={{ width: '80%' }}
            name="notes"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <TextArea
              style={{ width: '100%' }}
              placeholder="Enter your notes"
              rows={3}
            />
          </Form.Item>
        </Form>

        <Table
          tableLayout="auto"
          columns={columns}
          dataSource={items}
          onChange={onChangeTable}
          rowKey="id"
          size="small"
          loading={loadingPoint}
          scroll={{
            x: 'max-content',
          }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            total: total,
            current: filter.page,
            pageSize: filter.limit,
          }}
        />
      </Modal>
    </>
  );
};

export default FormPax;
